export default "__VITE_ASSET__CaweUHPB__"